import type React from 'react';
import type {DataValue} from 'schemaDefinition/types';
import {isNullish} from 'schemaDefinition';
import {useCodelist} from 'services/codelists';
import {useDataFormContext} from '../contexts';
import {
  DataFormMultiValue,
  type DataFormMultiValueProps,
} from './DataFormMultiValue';

export const DataFormMultiValueVisibilityWrapper: React.FC<
  DataFormMultiValueProps
> = props => {
  return props.part.hideIfNoOptionsAndEmpty ? (
    <DataFormMultiValueEmptyCheck {...props} />
  ) : (
    <DataFormMultiValue {...props} />
  );
};

export const DataFormMultiValueEmptyCheck: React.FC<
  React.PropsWithChildren<DataFormMultiValueProps>
> = ({part, useValue, valuePath, ...rest}) => {
  const {id} = useDataFormContext();
  const value = useValue(valuePath, id, part.name) as DataValue;
  const {codes} = useCodelist(part.codelistId);

  // Dont render if there is not value or options, to avoid showing empty field.
  return isNullish(value) && codes.length === 0 ? null : (
    <DataFormMultiValue
      part={part}
      useValue={useValue}
      valuePath={valuePath}
      {...rest}
    />
  );
};
